import { z } from 'zod';
import { LIMITS } from '../limits.js';

export const labelNameSchema = z
  .string()
  .trim()
  .min(1, 'Nom de libellé requis')
  .max(LIMITS.labelName, `Au plus ${LIMITS.labelName} caractères`);

export const createLabelSchema = z.object({ name: labelNameSchema });
export type CreateLabelInput = z.infer<typeof createLabelSchema>;

export const updateLabelSchema = z.object({ name: labelNameSchema });
export type UpdateLabelInput = z.infer<typeof updateLabelSchema>;

export interface LabelDto {
  id: string;
  name: string;
  createdAt: string;
}
